import { useDeliveryApi } from 'infrastructure/api';
import { AssumptionCreatePayload, AssumptionType, AssumptionUpdatePayload } from './types';

const useAssumptionsService = () => {
  const { sendPostRequest, sendPatchRequest } = useDeliveryApi();

  const createAssumption = async (projectId: string, payload: AssumptionCreatePayload): Promise<AssumptionType> => {
    const response = await sendPostRequest(`/projects/${projectId}/assumptions`, payload);
    return response.json();
  };

  const createAssumptionsBatch = async (
    projectId: string,
    batch: Pick<AssumptionCreatePayload, 'description' | 'assignedRole' | 'status'>[],
  ) => {
    const response = await sendPostRequest(`/projects/${projectId}/assumptions/batch`, {
      projectId,
      batch,
    });
    return response.json();
  };

  const updateAssumption = async (id: string, payload: AssumptionUpdatePayload): Promise<AssumptionType> => {
    const response = await sendPatchRequest(`/projects/assumptions/${id}`, payload);
    return response.json();
  };

  const changeAssumptionStatus = async (
    id: string,
    payload: { status: string; updatedBy?: string },
  ): Promise<AssumptionType> => {
    const response = await sendPatchRequest(`/projects/assumptions/${id}/status`, payload);
    return response.json();
  };

  const confirmAssumption = async (id: string): Promise<AssumptionType> => {
    const response = await sendPatchRequest(`/projects/assumptions/${id}/confirm`);
    return response.json();
  };

  const approveAssumptionException = async (id: string) => {
    const response = await sendPatchRequest(`/projects/assumptions/${id}/approve-request`);
    return response.json();
  };

  const rejectAssumptionException = async (id: string) => {
    const response = await sendPatchRequest(`/projects/assumptions/${id}/reject-request`);
    return response.json();
  };

  return {
    createAssumption,
    createAssumptionsBatch,
    updateAssumption,
    changeAssumptionStatus,
    confirmAssumption,
    approveAssumptionException,
    rejectAssumptionException,
  };
};

export default useAssumptionsService;
